import { AuthFormBoxRowGaps } from "/app/libraries/arcana/src/blocks/AuthFormBox/index.ts"
import { AuthFormBoxTemplate } from "/app/libraries/arcana/src/blocks/AuthFormBox/Templates/index.ts"
import { TextBlock, TextBlockDirection, TextBlockRowGap } from "/app/libraries/arcana/src/blocks/TextBlock/index.ts"
import { TextBoxHeadline2 } from "/app/libraries/arcana/src/atoms/TextBox/Templates/index.ts"

import { useUnit } from 'effector-react'
import { AuthTabs } from '~/features/change-auth-type'
import {
  RegistrationByEmailForm,
  RegistrationByPhoneForm,
  model as signUpModel,
} from '~/features/subscriber/sign-up'
import { useErrorMessage } from '~/widgets/Popups/MessagePortal'
import { $signUpFormTranslations } from './i18n'
import { $isSignUpByEmailActivated, $isSignUpByPhoneActivated } from './model'
import { SignInLink } from './SignInLink'

export const SignUpForm = () => {
  const formTranslations = useUnit($signUpFormTranslations)
  const message = useUnit(signUpModel.$message)

  const isPhoneRegistration = useUnit($isSignUpByPhoneActivated)
  const isEmailRegistration = useUnit($isSignUpByEmailActivated)

  const signUpWithPhoneEnabled = useUnit(signUpModel.$signUpWithPhoneEnabled)
  const rowGap = signUpWithPhoneEnabled
    ? AuthFormBoxRowGaps.SIZE_160
    : AuthFormBoxRowGaps.SIZE_150

  useErrorMessage(message, 'SignUpForm')

  return (
    <AuthFormBoxTemplate rowGap={rowGap}>
      <TextBoxHeadline2 title={formTranslations.title} />
      {signUpWithPhoneEnabled && <AuthTabs />}
      {isPhoneRegistration && <RegistrationByPhoneForm />}
      {isEmailRegistration && <RegistrationByEmailForm />}

      <TextBlock
        direction={TextBlockDirection.ROW}
        rowGap={TextBlockRowGap.INDENT_20}
      >
        <SignInLink />
      </TextBlock>
    </AuthFormBoxTemplate>
  )
}
